import client from '@/utils/request';
import { getApiUrlWithParams } from '@/utils/url';
import {
  AUTH_API_BASE_URL as API_BASE_URL,
  USERS_API_BASE_URL,
} from './base_url';

export const sendOtp = (data: any) => {
  return client.post(`${API_BASE_URL}/mobile_login_otp/`, data);
};

export const otpLogin = (mobileNumber: string, mobileLoginOtp: string) => {
  return client.post(`${API_BASE_URL}/login/`, {
    mobile_number: mobileNumber,
    mobile_login_otp: mobileLoginOtp,
  });
};

export const logout = () => {
  return client.post(`${API_BASE_URL}/logout/`);
};

export const getCurrentUser = () => {
  return client.get(`${USERS_API_BASE_URL}/users/current_user/`);
};

export const getWechatServiceConfig = (url: string) => {
  return client.get(`${API_BASE_URL}/wechat_service_config/?url=${url}`);
};

export const getWechatQrcodeConfig = () => {
  return client.get(`${API_BASE_URL}/wechat_qrcode_config/`);
};

export const wechatLogin = (scene_str: string) => {
  const requestUrl = getApiUrlWithParams(`${API_BASE_URL}/login/`, {
    scene_str,
  });
  return client.get(requestUrl);
};
